/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {GlobalAccountVoModel} from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class GlobalAccountResourceService extends AbstractResourceService<
  GlobalAccountVoModel,
  GlobalAccountVoModel,
  any,
  any
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('globalAccountUrl'),
      GlobalAccountVoModel,
      GlobalAccountVoModel
    );
  }
}
